module.exports = __webpack_public_path__ + "media/images/team/men-ea12c47a2f7d77aceaa01fe62282e739.png";